module.exports = __webpack_public_path__ + "media/audios/kid/lesson_5/audio_SebastiaoSaltitao-0efb2524220f81c09102e7622ff805e4.m4a";